import Vue from "vue";
import { Message } from 'element-ui';
import { getHttpHeader } from '~/common/plugins/ic-utils'
import store from '~/store/index'
export default {
	install: () => {
		let lockReconnect = false; //避免重复连接
		let isReconnect = true; //是否重连
		let clients, tt, wsUrl, global_callback;
		if (process.client) {
      let pre = location.protocol === 'https:' ? 'wss://' : 'ws://';
			wsUrl = pre + location.host + '/socket/general-ws/ws?token=' + getHttpHeader();
		}

		function createWebSocket(url) {
			if (clients?.readyState === 1) return
			url = url || wsUrl;
			try {
				if ('WebSocket' in window) {
					clients = new WebSocket(url);
				} else if ('MozWebSocket' in window) {
					clients = new MozWebSocket(url);
				} else {
					Message('您的浏览器不支持websocket协议,建议使用新版谷歌、火狐等浏览器，请勿使用IE10以下浏览器，360浏览器请使用极速模式，不要使用兼容模式！')
				}
				init();
			} catch (e) {
				console.log(e);
				if (isReconnect) {
					reconnect(url);
				}
			}
		}

		function init() {
			clients.onclose = function (e) {
				console.log("连接关闭!" + new Date().toLocaleTimeString());
				if (isReconnect) {
					reconnect(wsUrl);
				}
			};
			clients.onerror = function () {
				// Message('网络连接错误！')
				websocketClose(); //主动关闭连接
				console.log("连接错误!" + new Date().toLocaleTimeString());
				if (isReconnect) {
					reconnect(wsUrl);
				}
			};
			clients.onopen = function () {
				//心跳检测重置
				console.log('连接成功')
				heartCheck.reset().start();
				console.log("连接成功!" + new Date().toLocaleTimeString());
			};
			clients.onmessage = function (event) {
				//拿到任何消息都说明当前连接是正常的
				heartCheck.reset().start();
				let data = JSON.parse(event.data);
				store.commit('set_socketMsg', data)
				// console.log(`接收到${data.target}消息`);
				if (global_callback) {
					//注意，这里的global_callback 在导入场景两次通知时，不是同一函数
					global_callback(data)
				}
			}
		}
		if (process.client) {
			// 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口，server端会抛异常。
			window.onbeforeunload = function () {
				if (clients) {
					clients.close();
				}
			}

			//刷新页面后需要重连
			if (window.performance.navigation.type === 1) {
				if (isReconnect && getHttpHeader()) {
					reconnect(wsUrl);
				}
			}
		}

		function reconnect(wsUrl) {
			if (lockReconnect) return;
			lockReconnect = true;
			//没连接上会一直重连，设置延迟避免请求过多
			tt && clearTimeout(tt);
			tt = setTimeout(function () {
				if (clients && clients.readyState && clients.readyState == 1) {
					lockReconnect = false;
					return false;
				} else {
					createWebSocket(wsUrl);
					lockReconnect = false;
				}
			}, 4000);
		}

		//心跳检测
		let heartCheck = {
			timeout: 6000,
			timeoutObj: null,
			serverTimeoutObj: null,
			reset: function () {
				clearTimeout(this.timeoutObj);
				clearTimeout(this.serverTimeoutObj);
				return this;
			},
			start: function () {
				let self = this;
				this.timeoutObj = setTimeout(function () {
					websocketSend(JSON.stringify({ "target": "HeartBeat" }));
					isReconnect = getHttpHeader() ? true : false;
					self.serverTimeoutObj = setTimeout(function () {
						//如果超过一定时间还没重置，说明后端主动断开了
						//如果onclose会执行reconnect，我们执行ws.close()就行了.如果直接执行reconnect 会触发onclose导致重连两次
						if (clients) clients.close();
					}, self.timeout)
				}, this.timeout)
			}
		}

		let num = 5;
		// 实际调用的方法
		function sendSock(target, params, callback) {
			global_callback = callback;
			let agentData = JSON.stringify({
				target,
				params
			});
			if (clients && clients.readyState && clients.readyState === clients.OPEN) {
				//若是ws开启状态
				websocketSend(agentData)
			} else if (clients && clients.readyState && clients.readyState === clients.CONNECTING) {
				// 若是 正在开启状态，则等待1s后重新调用
				setTimeout(function () {
					sendSock(target, params, callback);
				}, 1000);
			} else {
				// 若未开启 ，则等待1s后重新调用
				setTimeout(function () {
					if (num > 0) {
						sendSock(target, params, callback);
					} else if (getHttpHeader) {
						reconnect(wsUrl);
						sendSock(target, params, callback);
					}
					num--;
				}, 1000);
			}
		}

		//数据发送
		function websocketSend(agentData) {
			if (clients) {
				clients.send(agentData);
			}
		}

		//主动关闭连接
		function websocketClose() {
			console.log("主动关闭连接!");
			isReconnect = false;
			if (clients) {
				clients.close();
			}
			clients = null;
			lockReconnect = false;
		}

		function handleData(callback) {
			if (clients && clients.readyState && clients.readyState === clients.OPEN) {
				//若是ws开启状态
				global_callback = callback;
			} else if (clients && clients.readyState && clients.readyState === clients.CONNECTING) {
				// 若是 正在开启状态，则等待1s后重新调用
				setTimeout(function () {
					handleData(callback)
				}, 1000);
			} else {
				// 若未开启 ，则等待1s后重新调用
				setTimeout(function () {
					if (num > 0) {
						handleData(callback)
					} else if (getHttpHeader) {
						reconnect(wsUrl);
						handleData(callback)
					}
					num--;
				}, 1000);
			}
		}

		Vue.prototype.$wsApi = {
			clients,
			sendSock,
			handleData,
			websocketClose,
			createWebSocket
		}
	}
}
